import { counterDepthIncreaseGranite } from './counter-depth-increase-granite/counter-depth-increase-granite';
import { fridge15TrimKit } from './fridge-trim-kit/fridge15-trim-kit';
import { fridge21TrimKit } from './fridge-trim-kit/fridge21-trim-kit';
import { fridge21TrimKitC121s } from './fridge-trim-kit/fridge21-trim-kit-c121s';
import { fridge21TrimKitGen3 } from './fridge-trim-kit/fridge21-trim-kit-gen3';
import { fridge24TrimKit } from './fridge-trim-kit/fridge24-trim-kit';
import { fridge24TrimKitGen3 } from './fridge-trim-kit/fridge24-trim-kit-gen3';
import { islandDepthIncrease } from './island-depth-increase/island-depth-increase';
import { nonCountertopSale } from './non-countertop-sale/non-countertop-sale';
import { nonCoyoteCountertopCutout } from './non-coyote-countertop-cutout/non-coyote-countertop-cutout';
import { nonCoyoteDropIn } from './non-coyote-drop-in/non-coyote-drop-in';
import { nonCoyoteSidePanel } from './non-coyote-side-panel/non-coyote-side-panel';
import { openingInCounter } from './opening-in-counter/opening-in-counter';
import { requiresCountertopSeam } from './requires-countertop-seam/requires-countertop-seam';
import { requiresPassthrough } from './passthrough/requires-passthrough';
import { requiresVenting } from './requires-venting/requires-venting';
import { shippingPromo } from './shipping-promo/shipping-promo';
// import { utilityCutout } from './utility-cutout/utility-cutout';
import { RuleScope } from '../constants';

export const rulesMap = {
	// requiresVenting triggers on fuel-sourced appliances
	requiresVenting: {
		func: requiresVenting,
		scope: RuleScope.Island
	},

	// trims kits are panel item rules
	fridge21TrimKit: {
		func: fridge21TrimKit,
		scope: RuleScope.PanelItem
	},
	fridge21TrimKitC121s: {
		func: fridge21TrimKitC121s,
		scope: RuleScope.PanelItem
	},
	fridge24TrimKit: {
		func: fridge24TrimKit,
		scope: RuleScope.PanelItem
	},
	fridge21TrimKitGen3: {
		func: fridge21TrimKitGen3,
		scope: RuleScope.PanelItem
	},
	fridge24TrimKitGen3: {
		func: fridge24TrimKitGen3,
		scope: RuleScope.PanelItem
	},
	fridge15TrimKit: {
		func: fridge15TrimKit,
		scope: RuleScope.PanelItem
	},
	shippingPromo: {
		func: shippingPromo,
		scope: RuleScope.PanelItem
	},
	requiresPassthrough: {
		func: requiresPassthrough,
		scope: RuleScope.Kitchen
	},

	// promotional sku auto-add rules (Kitchen scope)
	islandDepthIncrease: {
		func: islandDepthIncrease,
		scope: RuleScope.Kitchen
	},
	counterDepthIncreaseGranite: {
		func: counterDepthIncreaseGranite,
		scope: RuleScope.Kitchen
	},
	nonCoyoteCountertopCutout: {
		func: nonCoyoteCountertopCutout,
		scope: RuleScope.Kitchen
	},
	nonCoyoteDropIn: {
		func: nonCoyoteDropIn,
		scope: RuleScope.Kitchen
	},
	nonCoyoteSidePanel: {
		func: nonCoyoteSidePanel,
		scope: RuleScope.Kitchen
	},
	nonCountertopSale: {
		func: nonCountertopSale,
		scope: RuleScope.Kitchen
	},
	openingInCounter: {
		func: openingInCounter,
		scope: RuleScope.Kitchen
	},
	requiresCountertopSeam: {
		func: requiresCountertopSeam,
		scope: RuleScope.Island
	}
	// utilityCutout: {
	// 	func: utilityCutout,
	// 	scope: RuleScope.Kitchen
	// }
};
